import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import styles from "./index.module.css";

const SearchBar = ({ onSearch }) => {
  const handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    if (onSearch) {
      onSearch(searchTerm);
    }
  };

  return (
    <div className={styles.searchBarContainer}>
      <div className={styles.searchIcon}>
        <FontAwesomeIcon icon={faSearch} />
      </div>
      <input
        type="text"
        className={styles.searchInput}
        placeholder="Search"
        onChange={handleSearchChange}
      />
    </div>
  );
};

export default SearchBar;
